
import * as ApiUrls from "./ApiUrl.WhatsNew";
import { AxiosResponse } from "axios";
import { axiosCoreInstance } from "../AxiosCoreInterceptor";
import { WhatsNew } from "../../Model/Dto/WhatsNew";

export const WhatsNewService = {
    getAll: (): Promise<AxiosResponse<WhatsNew.Response[]>> => axiosCoreInstance.get(ApiUrls.GetAll),
}